import React, { Component } from 'react'
import { forIn } from 'lodash'
import Icon from 'components/icon/icon'

import SmoothCollapse from 'react-smooth-collapse'

import ControlsLikeContainer from 'components/controls-like-container/controls-like-container'

import { Container, Draggable } from 'react-smooth-dnd'

import MobileSubMenu from 'components/mobile/mobile-sub-menu'

import {
    isMobile
} from 'utils'

export default class ProjectFileFolders extends Component {
    tempCurrentlyDraggingDraggableId = null

    getCurrentFileFolders = _ => {
        const {
            allFileFolders,
            projectFolderChain
        } = this.props

        const fileFolders = []

        const lastFolderChainId = projectFolderChain.length ? projectFolderChain[(projectFolderChain.length - 1)] : null

        forIn(allFileFolders, fileFolder => {
            if(fileFolder.deleted_at){
                return 
            }
            
            if (fileFolder.file_folder_id === lastFolderChainId) {
                fileFolders.push(fileFolder)
            }
        })

        return fileFolders
    }

    openFileFolder = fileFolder => {
        const {
            updateProjectFolderChain,
            projectFolderChain,
            currentlyDraggedObject
        } = this.props

        if(currentlyDraggedObject){
            return
        }

        let newFolderChain = []

        if (fileFolder && fileFolder.id) {
            newFolderChain = [...projectFolderChain]

            const folderIndexIfExists = newFolderChain.indexOf(fileFolder.id)

            if (folderIndexIfExists == -1) {
                newFolderChain.push(fileFolder.id)
            } else {
                newFolderChain.length = (folderIndexIfExists + 1)
            }
        }

        updateProjectFolderChain(newFolderChain)
    }

    render() {
        const {
            projectFolderChain,
            allFileFolders,
            onDrop,
            onDragStart,
            onDragEnd,
            editFileFolder,
            deleteFileFolder,
            setlastHoveredFileFolder,
            currentlyDraggedObject,
            isList,
            blockFileTransition
        } = this.props

        const currentFolders = this.getCurrentFileFolders()

        let listClassName = "project-file-folders files-grid-list visible"

        if(isList){
            listClassName += ' list'
        }

        if(blockFileTransition){
            listClassName += ' transitioning'
        }

        return (
            <div className="project-file-folders-container">
                { !isList ?
                    <SmoothCollapse
                        expanded={!!projectFolderChain.length}
                        allowOverflowWhenOpen={true}
                    >
                        <ul className="breadcrumbs">
                            { [null, ...projectFolderChain].map(fileFolderId => {
                                let fileFolder = {
                                    id: null,
                                    name: 'Files'
                                }

                                if(fileFolderId){
                                    fileFolder = allFileFolders[fileFolderId]
                                }

                                if(!fileFolder || fileFolder.deleted_at){
                                    return null
                                }

                                return (
                                    <Container
                                        onDrop={e => { onDrop(e, fileFolder) }}
                                        key={fileFolderId}
                                        onDragStart={onDragStart}
                                        onDragEnd={onDragEnd}
                                        orientation="horizontal"
                                        behaviour="drop-zone"
                                        groupName="files"
                                        render={setRef => (
                                            <li 
                                                ref={setRef}
                                                onMouseEnter={_ => {
                                                    setlastHoveredFileFolder(fileFolder)
                                                }}
                                                onMouseLeave={_ => {
                                                    setlastHoveredFileFolder(fileFolder, true)
                                                }}
                                            >
                                                <Draggable key={fileFolder.id}>
                                                    <button
                                                        onClick={_ => {
                                                            this.openFileFolder(fileFolder)
                                                        }}
                                                    >
                                                        {fileFolder.name}
                                                    </button>
                                                </Draggable>
                                            </li>
                                        )}
                                    />
                                )
                            })}
                        </ul>
                    </SmoothCollapse>
                : null }
                <SmoothCollapse
                    expanded={!!currentFolders.length}
                    allowOverflowWhenOpen={true}
                >
                    { !isList ?
                        <label className="separator">
                            File folders
                        </label>
                    : null }
                    <ul className={listClassName}>
                        {currentFolders.map((fileFolder, index) => {
                            const isBeingDragged = currentlyDraggedObject && currentlyDraggedObject.type == 'folder' && currentlyDraggedObject.object.id == fileFolder.id

                            const mobilesubMenuOptions = [
                                {
                                    icon: 'fe-edit-2',
                                    label: 'Edit',
                                    callback: _ => {
                                        editFileFolder(fileFolder)
                                    }
                                },{
                                    icon: 'fe-trash-2',
                                    label: 'Delete',
                                    callback: _ => {
                                        deleteFileFolder(fileFolder)
                                    }
                                }
                            ]

                            return (
                                <Container
                                    onDrop={e => { onDrop(e, fileFolder) }}
                                    key={fileFolder.id}
                                    onDragStart={onDragStart}
                                    onDragEnd={onDragEnd}
                                    orientation="horizontal"
                                    behaviour="drop-zone"
                                    groupName="files"
                                    getChildPayload={_ => {
                                        return {
                                            type: 'folder',
                                            object: fileFolder
                                        }
                                    }}

                                    render={setRef => (
                                        <li 
                                            ref={setRef}
                                            onMouseEnter={_ => {
                                                setlastHoveredFileFolder(fileFolder)
                                            }}
                                            onMouseLeave={_ => {
                                                setlastHoveredFileFolder(fileFolder, true)
                                            }}
                                            style={{
                                                zIndex: (currentFolders.length - index)
                                            }}
                                        >
                                            <Draggable key={fileFolder.id}>
                                                <div>
                                                    <div
                                                        onClick={_ => { this.openFileFolder(fileFolder) }}
                                                        className={isBeingDragged ? 'is-being-dragged button-proxy' : 'button-proxy'}
                                                    >
                                                        <Icon name={'folder-o'} />
                                                        <span className="folder-name">
                                                            {fileFolder.name}
                                                        </span>
                                                        { isMobile() ?
                                                            <MobileSubMenu options={mobilesubMenuOptions} />
                                                        :
                                                            <ControlsLikeContainer
                                                                canEdit={true}
                                                                editCallback={_ => editFileFolder(fileFolder)}
                                                                deleteCallback={_ => deleteFileFolder(fileFolder)}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </Draggable>
                                        </li>
                                    )
                                    } />
                            )
                        })}
                    </ul>
                </SmoothCollapse>
            </div>
        )
    }
}
